module.exports = __webpack_public_path__ + "img/Mask Group 139.7b77b2d9.svg";